export { Subtitle2 } from './Subtitle2';
export { subtitle2ClassNames } from './useSubtitle2Styles.styles';
